import { Grid, Box } from '@oresundsbron/bridge-ui';
export const InfoSkeleton = () => (
  <Grid className="col-start-2">
    <Box className="col-span-2 row-start-1 mb-2 h-[28px] animate-pulse bg-neutral-400" />
    <Box className="col-span-2 row-start-2 flex flex-col gap-2 pb-2 sm:col-span-3">
      <Box className="h-[16px] w-1/2 animate-pulse bg-neutral-400" />
      <Box className="h-[16px] w-full animate-pulse bg-neutral-400" />
    </Box>
    <Box className="col-span-2 row-start-2 flex flex-col gap-2 pb-2 sm:col-span-3">
      <Box className="h-[16px] w-1/2 animate-pulse bg-neutral-400" />
      <Box className="h-[16px] w-full animate-pulse bg-neutral-400" />
    </Box>
  </Grid>
);
